import {
  ChangeDetectionStrategy,
  Input,
  Component,
  ElementRef,
  HostBinding,
  Output,
  EventEmitter,
  signal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { zAppDevComponentSize } from "../component-size";
import { zAppDevComponentStatus } from "../component-status";

import * as ThemeOptions from "../../theme/interfaces/options";
import { IThemeSevice } from "../../theme/interfaces/theme.interface";
import { ValueFormat } from "../../core/clms.fw.angular";
import { CF_COMPONENT } from "../../rule-engine/directives/condition-formatting.directive";
import { zAppDevBaseComponent } from "../BaseComponent/base.component";

@Component({
  selector: "[zappLabel]",
  templateUrl: './label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CF_COMPONENT, useExisting: zAppDevLabelComponent }],
  standalone: true,
  imports: [CommonModule]
})
export class zAppDevLabelComponent extends zAppDevBaseComponent {

  _value = signal<any>(null);
  private _valueFormat: ValueFormat;

  @Input()
  set value(value) {
    let valueWasNull = false;
    if (value == null || value == undefined) {
      valueWasNull = true;
      value = "";
    }
    if (this._valueFormat === undefined || this.type == "string") {
      this._value.set(value);
    } else {
      this._value.set(valueWasNull ? "" : this._valueFormat.format(value));
    }
  }

  _innerHtmlValue = signal<any>(null);
  @Input()
  set innerHTMLValue(val) {
    this._innerHtmlValue.set(this.getHtml(val));
  }

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() type: any;

  @Input()
  set valueFormat(format: any) {
    if (format != null) {
      this._valueFormat = new ValueFormat(format);
    }
  }

  @Input() variation: string = "Standard";

  @Input() size: zAppDevComponentSize = "med";

  @Input() status: zAppDevComponentStatus = "global";

  @Input() class: string = "";

  options: ThemeOptions.LabelThemeOptions;

  constructor(private themeService: IThemeSevice, protected elementRef: ElementRef) {
    super(elementRef);
    this.options = this.themeService.getLabelThemeOptions();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  setValue(value: string, fromCalculated: boolean = false) {
    this.value = value; // goes through the @Input setter which calls _value.set()
    if (fromCalculated === true) {
      this.valueChange.emit(value);
    }
  }

  @HostBinding('class')
  get hostClasses(): string {
    return this.hostClassesArray().concat(this.styleClassesArray()).join(' ');
  }

  @HostBinding('class.hidden')
  get hiddenClass() {
    return this.hidden ? "hidden" : "";
  }

  getHtml(value: any) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = value;
    const html = textArea.value;
    textArea.remove();
    return html;
  }
}
